<template>
  <div class="viewer-item mb-5" :class="{'viewer-item--connected' : isConnected}">
    <div v-if="viewer.waving" class="viewer-item__hand">👋</div>
    <div class="viewer-item__avatar">
      <div class="animoji">
        <img :class="{'grayscale' : !viewer.online}" :src="animojis[viewer.avatar]" />
      </div>
    </div>
    <v-col class="px-5 py-0" :align="'start'">
      <p class="bold my-0">{{ viewer.name ? viewer.name : viewer.email.split('@')[0] }}</p>
      <p class="py-0 lighten smaller mb-0" :class="{ 'color-primary' : viewer.online}">
        <!-- eslint-disable-next-line max-len -->
        {{ upperFirst($t(viewer.online ? 'online' : 'offline')) }}
      </p>
    </v-col>
    <!-- eslint-disable-next-line max-len -->
    <template v-if="(viewer.online && isTeacher) || (isConnected && isTeacher)">
      <v-btn
        v-if="isConnected"
        depressed
        class="background-danger color-white"
        rounded
        @click="disconnect"
      >
        <v-icon class="pe-5" right dark>mdi-volume-off</v-icon>
        {{ $t('videoEnd') }}
      </v-btn>
      <v-tooltip v-else-if="isLive && viewer.voiceless"  top>
        <template v-slot:activator="{ on }">
          <p class="lighten viewer-item__voiceless mb-0" v-on="on">{{ $t('voiceless') }}</p>
        </template>
        <span>{{ $t('noMicButHears') }}</span>
      </v-tooltip>
      <v-btn
        v-else-if="isLive"
        depressed
        color="secondary"
        rounded
        class="color-primary"
        @click="connect"
      >
        <v-icon class="pe-5" right dark>mdi-volume-high</v-icon>
        {{ $t('videoConnect') }}
      </v-btn>
    </template>
    <v-icon v-else-if="isConnected" class="viewer-item__icon color-primary me-4">mdi-video</v-icon>
  </div>
</template>

<script>
import upperFirst from 'lodash/upperFirst';
import { animojis } from '@/main.js';

export default {
  props: {
    viewer: {
      type: Object,
      required: true,
    },
    lesson: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },

  computed: {
    isTeacher() {
      return !this.$route.params.viewer;
    },

    isLive() {
      return this.lesson.status === 'live';
    },

    animojis() {
      return animojis;
    },
    isConnected() {
      return this.viewer.connected;
    },
    windowIndex() {
      return this.lesson.windows.findIndex(
        w => w.participant === this.viewer.email,
      );
    },
  },

  methods: {
    upperFirst,
    connect() {
      this.$emit('connect', this.viewer);
    },
    disconnect() {
      this.$emit('disconnect', this.viewer);
    },
  },
};
</script>

<style lang="scss">
.viewer-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;

  &__voiceless {
    cursor: help;
  }

  &--connected {
    animation: myship 0.2s;
    border-bottom-left-radius: 0;
    background: #d8eefe;
    position: relative;
    border-radius: 50px;
    padding: 5px 10px;
    border-bottom-left-radius: 0;
  }

  &__avatar {
    min-width: 40px;
    width: 40px;
  }
  &__hand {
    position: relative;
    margin-left: -17px;
    font-size: 30px;
    z-index: 1;
    animation: wave 0.45s infinite linear alternate;
    @media (max-width: 1024px) {
      margin-left: auto;
      left: 10px;
    }
  }
}

@keyframes wave {
  from {
    transform: rotate(-25deg);
  }
  to {
    transform: rotate(50deg);
  }
}
</style>
